export const COOKIES_NAMES = {
  FAVORITE_DEVICES: 'FAVORITE_DEVICES',
  COMPARISON_DEVICES: 'COMPARISON_DEVICES',
};
